import { render, staticRenderFns } from "./carAddParkingSpaceList.vue?vue&type=template&id=1887f898&scoped=true"
import script from "./carAddParkingSpaceList.vue?vue&type=script&lang=js"
export * from "./carAddParkingSpaceList.vue?vue&type=script&lang=js"
import style0 from "./carAddParkingSpaceList.vue?vue&type=style&index=0&id=1887f898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887f898",
  null
  
)

export default component.exports